import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { LeadMobileNumberComponent } from '@leads/customer-facing/components/forms/lead-mobile-number/lead-mobile-number.component';
import { ILeadRequestForm } from '@leads/customer-facing/models/domain/lead-request.domain';
import { LeadRequestFormService } from '@leads/customer-facing/services/lead-request-form/lead-request-form.service';
import { CustomerLeadRequestRoutes } from '@leads/leads.routes';
import { IOrganisation } from '@organisations/models/organisations';
import { OrganisationService } from '@organisations/services/organisation/organisation.service';
import { LoadingStateComponent } from '@shared/components/loading-state/loading-state.component';

@Component({
	selector: 'app-lead-request-mobile-number',
	imports: [CommonModule, RouterLink, LeadMobileNumberComponent, LoadingStateComponent],
	templateUrl: './lead-request-mobile-number.component.html',
	styleUrl: './lead-request-mobile-number.component.scss',
})
export class LeadRequestMobileNumberComponent implements OnInit, OnDestroy {
	private leadRequestFormService = inject(LeadRequestFormService);
	private organisationService = inject(OrganisationService);
	private route = inject(ActivatedRoute);

	destroyed$ = new EventEmitter<void>();
	isLoading = true;

	organisationId: string;
	organisation: IOrganisation;
	leadRequestForm: FormGroup<ILeadRequestForm>;

	CustomerLeadRequestRoutes = CustomerLeadRequestRoutes;

	ngOnInit(): void {
		this.leadRequestForm = this.leadRequestFormService.getForm();
		this.organisationId = this.route.parent?.parent?.snapshot.params.organisationId;

		this.organisationService.getDocSnapshot(this.organisationId).then((doc) => {
			if (doc.exists()) {
				this.organisation = doc.data();
			}
			this.isLoading = false;
		});
	}

	ngOnDestroy(): void {
		this.destroyed$.emit();
	}
}
